var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestfour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g6879",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.48,
    height: 77.48,
    viewBox: "0 0 77.48 77.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6885",
    d: "M0-682.665H77.48v77.48H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6883",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6889",
    transform: "translate(2.328 5.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6891",
    d: "M-167.051-49.084v-2.535a2.731,2.731,0,0,0-2.725-2.743,2.673,2.673,0,0,0-2.622,2.673v-1.006a2.673,2.673,0,0,0-2.673-2.673,2.673,2.673,0,0,0-2.674,2.673v2.012a2.673,2.673,0,0,0-2.622-2.673,2.73,2.73,0,0,0-2.725,2.743v2.948a2.673,2.673,0,0,0-2.622-2.673,2.731,2.731,0,0,0-2.725,2.743V-36.8",
    transform: "translate(188.438 55.368)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6893",
    transform: "translate(23.715 28.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6895",
    d: "M0-121.452v-6.028l3.08-1.32a2.972,2.972,0,0,0,1.744-2.151l1.2-6.05",
    transform: "translate(0 137.001)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6897",
    transform: "translate(23.715 71.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6899",
    d: "M0-17.7v-2.266",
    transform: "translate(0 19.964)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6901",
    transform: "translate(7.722 66.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6903",
    d: "M0,0V8.2",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6905",
    transform: "translate(2.328 28.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6907",
    d: "M0,0V4.828A5.433,5.433,0,0,0,1.159,8.182L3.35,10.975A9.587,9.587,0,0,1,5.26,15.3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6909",
    transform: "translate(18.368 9.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6911",
    d: "M0,0V14.974",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6913",
    transform: "translate(13.022 10.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6915",
    d: "M0,0V13.968",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6917",
    transform: "translate(7.675 13.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6919",
    d: "M0,0V10.951",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6921",
    transform: "translate(1.135 44.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6923",
    d: "M-361.157-42.129h-5.787a9.585,9.585,0,0,1-5.916-2.044l-2.793-2.191a5.434,5.434,0,0,0-3.354-1.159h-20.615a2.731,2.731,0,0,0-2.743,2.725,2.673,2.673,0,0,0,2.673,2.622h-2.948a2.731,2.731,0,0,0-2.743,2.725,2.674,2.674,0,0,0,2.673,2.622h-2.012a2.673,2.673,0,0,0-2.673,2.673,2.673,2.673,0,0,0,2.673,2.673h1.006a2.673,2.673,0,0,0-2.673,2.622,2.73,2.73,0,0,0,2.743,2.725h18.831v6.089l6.352-1.265a2.972,2.972,0,0,0,2.152-1.744l1.32-3.08h19.772",
    transform: "translate(407.395 47.523)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6925",
    transform: "translate(5.268 60.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6927",
    d: "M0,0H14.974",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6929",
    transform: "translate(6.274 54.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6931",
    d: "M0,0H13.968",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6933",
    transform: "translate(9.292 49.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6935",
    d: "M0,0H10.951",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6937",
    transform: "translate(23.715 28.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6939",
    d: "M0,0V3.408",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6941",
    transform: "translate(47.676 33.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6943",
    d: "M-47.563,0V6.028l-3.08,1.32A2.973,2.973,0,0,0-52.387,9.5l-1.265,6.352h6.089v3.684",
    transform: "translate(53.652)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6945",
    transform: "translate(53.765 3.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6947",
    d: "M0,0V2.266",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6949",
    transform: "translate(69.759 3.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6951",
    d: "M0-63.348v-8.11",
    transform: "translate(0 71.458)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6953",
    transform: "translate(53.765 33.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6955",
    d: "M0-194.92v10.155a2.731,2.731,0,0,0,2.725,2.743A2.673,2.673,0,0,0,5.347-184.7v1.006a2.673,2.673,0,0,0,2.673,2.673,2.673,2.673,0,0,0,2.674-2.673V-185.7a2.673,2.673,0,0,0,2.622,2.673,2.73,2.73,0,0,0,2.725-2.743v-2.947a2.674,2.674,0,0,0,2.622,2.673,2.731,2.731,0,0,0,2.725-2.743V-209.4a5.433,5.433,0,0,0-1.159-3.354l-2.191-2.793a9.582,9.582,0,0,1-1.911-4.324",
    transform: "translate(0 219.875)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6957",
    transform: "translate(59.112 53.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6959",
    d: "M0-116.96v-14.974",
    transform: "translate(0 131.934)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6961",
    transform: "translate(64.459 53.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6963",
    d: "M0-109.1v-13.968",
    transform: "translate(0 123.073)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6965",
    transform: "translate(69.805 53.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6967",
    d: "M0-85.533V-96.484",
    transform: "translate(0 96.484)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6969",
    transform: "translate(23.715 5.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6971",
    d: "M-75.127-47.563h-9.618v15.994h12.179a9.585,9.585,0,0,1,5.916,2.044l2.793,2.191A5.433,5.433,0,0,0-60.5-26.175h20.615A2.731,2.731,0,0,0-37.145-28.9a2.673,2.673,0,0,0-2.673-2.622h2.948a2.73,2.73,0,0,0,2.743-2.725A2.673,2.673,0,0,0-36.8-36.869h2.012a2.674,2.674,0,0,0,2.673-2.673,2.673,2.673,0,0,0-2.673-2.673h-1.006a2.673,2.673,0,0,0,2.673-2.622,2.73,2.73,0,0,0-2.743-2.725H-54.7v-6.089l-6.352,1.265A2.973,2.973,0,0,0-63.2-50.643l-1.32,3.08h-5.615",
    transform: "translate(84.745 53.652)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6973",
    transform: "translate(57.238 17.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6975",
    d: "M-116.96,0h-14.974",
    transform: "translate(131.934)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6977",
    transform: "translate(57.238 22.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6979",
    d: "M-109.1,0h-13.968",
    transform: "translate(123.072)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6981",
    transform: "translate(57.238 27.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6983",
    d: "M-85.533,0H-96.484",
    transform: "translate(96.484)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6985",
    transform: "translate(53.765 45.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6987",
    d: "M0-25.438v-3.257",
    transform: "translate(0 28.695)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6989",
    transform: "translate(51.04 11.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6991",
    d: "M-17.741,0h-2.271",
    transform: "translate(20.012)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6993",
    transform: "translate(24.018 65.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6995",
    d: "M0,0H2.182",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestfour);
export default __webpack_public_path__ + "static/media/testfour.ee88ba52e94b52b4cee66107e5ba0bc4.svg";
export { ForwardRef as ReactComponent };